import { render, staticRenderFns } from "./editMember.vue?vue&type=template&id=50ffcdd2&scoped=true"
import script from "./editMember.vue?vue&type=script&lang=js"
export * from "./editMember.vue?vue&type=script&lang=js"
import style0 from "./editMember.vue?vue&type=style&index=0&id=50ffcdd2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ffcdd2",
  null
  
)

export default component.exports